import { CompanyDataProvider } from '../reducers/companySearch.reducer';

export enum CampaignMemberStatus {
  New = 0,
  Pending = 1,
  Registered = 2,
  Suspended = 3
}

export interface CampaignMemberDto {
  campaignId: string;
  leadId: string;
  hiringClientOrgId: string | null;
  referralCode: string;
  discount: number;
  campaignMemberId: string;
  campaignName: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phoneNumber: string | null;
  company: string;
  isDeleted: boolean;
  campaignMemberStatus: CampaignMemberStatus;
}

export type ArrayMinLengthThree<T> = [T, T, T];
export interface JourneyProgressBarItem {
  id: number | string;
  title: string;
}
export interface Payer {
  label: string;
  value: string;
}

export enum PaymentMethodType {
  ACH = 'ACH',
  CreditCard = 'CreditCard'
}

export enum PayerVariants {
  Billing = 'billing',
  Company = 'company',
  New = 'new'
}

export interface BillingContactForm {
  firstName: string;
  lastName: string;
  country: string;
  countryIso3: string;
  countryIso2: string;
  address1: string;
  address2: string;
  city: string;
  region: string;
  regionId: string;
  postalCode: string;
  phone: string;
  email: string;
}

export type SignUpForm = {
  // Administrator Section fields
  firstName: string;
  lastName: string;
  title: string;
  email: string;
  phone: string;

  // Company Address  fields
  country: string;
  preferredLanguage?: string;
  countryIso3: string;
  countryIso2: string;
  region: string;
  regionId: string;
  city: string;
  address1: string;
  address2: string;
  companyEmail: string;
  companyPhoneNumber: string;
  postalCode: string;
  companyWebsite: string;

  // Company Information fields
  legalBusinessName: string;
  operatingAs: string;

  // Referral Code fields
  hasReferralCode?: boolean;
  referralCode?: string;
  referralCodeValidated?: boolean;
  isBusinessTaxRegistered?: boolean;
} & Record<string, string | string[] | boolean | undefined>;

export type AccountDataType = {
  name: string;
  operatingAs: string;
  isBusinessTaxRegistered?: boolean;
  taxId: string;
  employees: number;
  paymentMethod: string;
  referralCode: string | null;
  hiringClientCompanyId: number | null;
  email: string;
  phone: string;
  website: string;
  isSubcontractor: boolean;
  sku: string | null;
  specialPricingId: string | null;
  locale: string;
  registrationNumbers: { countryConfigId: string; typeId: number; value: string }[];
  organizationMetadata: { typeId: number; value: string }[];
  organizationProviderData: { provider: CompanyDataProvider; providerData: string }[];
  physicalAddress: {
    country: string;
    countryIso2: string;
    state: string;
    stateId: string;
    city: string;
    postalCode: string;
    address1: string;
    address2: string;
  };
  billingAddress: {
    country: string;
    countryIso2: string;
    state: string;
    stateId: string;
    city: string;
    postalCode: string;
    address1: string;
    address2: string;
  };
  administratorContact: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    title: string;
  };
  billingContact: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    title: string;
  };
};

export type ZuoraIframe = {
  Z: {
    render(...args: any[]): void;
  };
} & Window &
  typeof globalThis;
